<template>
	<div class="IncidenciasListado">
		<h1>Incidencias</h1>
		<md-table-card class="w-100">
			<md-toolbar>
				<h1 class="md-title">Incidencias atendidas</h1>
			</md-toolbar>
			<md-table>
				<md-table-header>
					<md-table-row>
						<md-table-head>Fecha</md-table-head>
						<md-table-head>Incidencia</md-table-head>
						<md-table-head>Punto</md-table-head>
						<md-table-head>Estatus</md-table-head>
						<md-table-head>Acciones</md-table-head>
					</md-table-row>
				</md-table-header>
				<md-table-body>
					<md-table-row v-for="i in incidencias" :key="i">
						<md-table-cell>{{i.fecha_ipu}}</md-table-cell>
						<md-table-cell>{{i.obs_ipu}}</md-table-cell>
						<md-table-cell>{{i.nombre_pun}}</md-table-cell>
						<md-table-cell>{{i.estatus_ipu.toUpperCase()}}</md-table-cell>
						<md-table-cell></md-table-cell>
					</md-table-row>
				</md-table-body>
			</md-table>
		</md-table-card>
	</div>
</template>

<script>
	import sha1 from 'js-sha1'
	import md5 from 'blueimp-md5'
	import Snackbar from 'node-snackbar'
	import $ from "jquery"
	import dt from "datatables.net"
	export default {
		name: 'IncidenciasListado',
		methods: {
			obtenerIncidencias(){
				this.$http.post('incidencias',{
					'token': this.$session.get('token'),
					estatus: 'atendidas'
				})
				.then(response => {
					if (response.status === 200 && 'incidencias' in response.body) {
						this.incidencias = response.body.incidencias
					}
				}, response => {
					Snackbar.show({
						text:'No se pudo establecer conexión con el servidor al obtener las incidencias.',
						actionText:'Cerrar',
						pos: 'top-right',
						showAction: false,
						backgroundColor:'#F44336',
						actionTextColor:'#FFF'
					});
				});
			},
		},
		beforeCreate(){
			if (!this.$session.exists()) {
				this.$router.push('/login')
			}
		},
		created(){
			this.obtenerIncidencias();
		},
		updated(){
			this.tabla = $('.md-table table').DataTable();
		},
		data(){
			return {
				msg: 'IncidenciasListado',
				incidencias: [],
				tabla : null,
			}
		}
	}
</script>


// WEBPACK FOOTER //
// IncidenciasAtendidasListado.vue?73e6ef96